import { render, staticRenderFns } from "./InvalidTablet.vue?vue&type=template&id=a05fa69e&scoped=true&"
import script from "./InvalidTablet.vue?vue&type=script&lang=js&"
export * from "./InvalidTablet.vue?vue&type=script&lang=js&"
import style0 from "./InvalidTablet.vue?vue&type=style&index=0&id=a05fa69e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05fa69e",
  null
  
)

export default component.exports